<template>
	<div class="clickable" @click="onCellClick">
		<div v-show="isEditing">
			<dms-check v-if="isBoolean" class="table-checkbox" :value.sync="editValueCmp" v-bind="{validationOff, type}" :disabled="false" />
			<dms-input-number v-else-if="isNumber" class="table-input" :value.sync="editValueCmp" v-bind="{validationOff, required}"
				:precision="precisionCmp" :disabled="false" @keydown="$emit('keydown', $event)" />

			<dms-input v-else class="table-input" :value.sync="editValueCmp" v-bind="{validationOff, type, required, maxlength}" :autosize="{ minRows: 1 }"
				:disabled="false" @keydown="$emit('keydown', $event)" />
		</div>
		<div v-show="!isEditing">
			<i v-if="isBoolean" :class="booleanIcon" />
			<span v-else>
				<i v-if="isIcon" :class="iconClass" />{{ formatedValue || ' ' }}</span>
		</div>
	</div>
</template>

<script>

import DmsTableCell from '#components/dms/layout/TableCell.vue';

export default DmsTableCell.extend({
	name: 'DmsEditableTableCell',
	props: {
		isEditing: Boolean,
		required: Boolean,
		validationOff: { type: Boolean, default: true },
		type: { type: String },
		precision: Number,
		maxlength: Number,
		item: Object,
		editingValue: { type: [String, Number, Boolean, Date, Object, Array], default: null },
	},
	data() {
		return {
			clicks: 0,
			delay: 250,
			timer: null,
		};
	},
	computed: {
		precisionCmp() {
			if (this.precision) { return this.precision; }
			return this.valueType === 'Decimal' ? 2 : 0;
		},
		isNumber() {
			return this.valueType === 'Decimal' || this.valueType === 'Int32';
		},
		editValueCmp: {
			get() {
				return this.editingValue;
			},
			set(val) {
				this.$emit('update:editingValue', val);
			},
		},
	},
	methods: {
		onCellClick() {
			this.clicks += 1;
			if (this.clicks === 1) {
				const self = this;
				this.timer = setTimeout(() => {
					this.$emit('edit-cell-click');
					self.clicks = 0;
				}, this.delay);
			} else {
				clearTimeout(this.timer);
				this.$emit('edit-cell-dblclick');
				this.clicks = 0;
			}
		},
	},


});
</script>

<style lang="scss" scoped>
.clickable {
	cursor: pointer;
}
.ellipsis td:before {
	content: '&nbsp;';
	visibility: hidden;
}
.ellipsis span {
	position: absolute;
	left: 0;
	right: 0;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
span {
	white-space: pre;
}

.table-input.frm-group {
	margin: 0 -10px;
}
.table-checkbox {
	margin-top: 0px;
	margin-bottom: 0px;
}
</style>
